// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3hTYR","cell":"ColumnAccessor_cell__2uqz8","firstCellAccent":"ColumnAccessor_firstCellAccent__ZzGwU"};